import React from "react";
import { EveButton } from "@eveworld/ui-components";

interface ButtonProps {
  CharacterAddress: string;
}

const ButtonDappLink: React.FC<ButtonProps> = ({ CharacterAddress }) => {
  const handleSimulate = async (SmartObjectId: string) => {
    window.open(
      "http://reapers.website/tribemember/?s=" + CharacterAddress,
      "_blank"
    );
  };

  return (
    <EveButton
      typeClass="primary"
      onClick={() => handleSimulate(CharacterAddress)}
    >
      Simulate
    </EveButton>
  );
};

export default React.memo(ButtonDappLink);
